import { usePageTitle } from "../../hooks/usePageTitle";

export default function PageTitleManager() {
	usePageTitle();
	return null;
}
